import { ToastMessage } from "freespace-react-components";
import AppContainer from "./routes";
import { toastRef } from "./services/toastService";

function App() {
  return (
    <>
      <ToastMessage ref={toastRef} position="bottom-right" />
      <AppContainer />
    </>
  );
}

export default App;
